import React, { useState } from 'react';
import styled from 'styled-components';
import GlobalStyles from './components/GlobalStyles';
import StartScreen from './components/StartScreen';
import MultipleChoiceQuestion from './components/MultipleChoiceQuestion';
import TrueFalseQuestion from './components/TrueFalseQuestion';
import ProgressBar from './components/ProgressBar';
import ResultScreen from './components/ResultScreen';
import { multipleChoiceQuestions, trueFalseQuestions } from './data/questions';

const AppContainer = styled.div`
  min-height: 100vh;
  padding: 2rem 1rem;
  background-color: #F0F8FF;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 1rem;
`;

const Title = styled.h1`
  color: #4169E1;
  font-size: 1.8rem;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

function App() {
  const [gameState, setGameState] = useState('start'); // start, playing, result
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [answers, setAnswers] = useState(Array(10).fill(null));
  
  const allQuestions = [...multipleChoiceQuestions, ...trueFalseQuestions];
  const currentQuestion = allQuestions[currentQuestionIndex];
  const isMultipleChoice = currentQuestionIndex < multipleChoiceQuestions.length;
  
  const handleStart = () => {
    setGameState('playing');
    setCurrentQuestionIndex(0);
    setScore(0);
    setAnswers(Array(10).fill(null));
  };
  
  const handleAnswer = (answer) => {
    const newAnswers = [...answers];
    newAnswers[currentQuestionIndex] = answer;
    setAnswers(newAnswers);
    
    const isCorrect = isMultipleChoice 
      ? answer === currentQuestion.correctAnswer
      : answer === currentQuestion.isTrue;
      
    if (isCorrect) {
      setScore(score + 1);
    }
  };
  
  const handleNext = () => {
    if (currentQuestionIndex < allQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      setGameState('result');
    }
  };
  
  const handleRestart = () => {
    setGameState('start');
  };
  
  return (
    <AppContainer>
      <GlobalStyles />
      
      {gameState === 'start' && (
        <StartScreen onStart={handleStart} />
      )}
      
      {gameState === 'playing' && (
        <>
          <Header>
            <Title>Η Ελληνική Οικονομία μετά την Επανάσταση</Title>
          </Header>
          
          <ProgressBar 
            currentQuestion={currentQuestionIndex + 1} 
            totalQuestions={allQuestions.length}
            score={score}
          />
          
          {isMultipleChoice ? (
            <MultipleChoiceQuestion
              question={currentQuestion.question}
              options={currentQuestion.options}
              correctAnswer={currentQuestion.correctAnswer}
              feedbackCorrect={currentQuestion.feedbackCorrect}
              feedbackIncorrect={currentQuestion.feedbackIncorrect}
              questionNumber={currentQuestionIndex + 1}
              totalQuestions={allQuestions.length}
              onAnswer={handleAnswer}
              onNext={handleNext}
              answered={answers[currentQuestionIndex]}
              selectedOption={answers[currentQuestionIndex]}
            />
          ) : (
            <TrueFalseQuestion
              question={currentQuestion.question}
              isTrue={currentQuestion.isTrue}
              feedbackCorrect={currentQuestion.feedbackCorrect}
              feedbackIncorrect={currentQuestion.feedbackIncorrect}
              questionNumber={currentQuestionIndex + 1}
              totalQuestions={allQuestions.length}
              onAnswer={handleAnswer}
              onNext={handleNext}
              answered={answers[currentQuestionIndex]}
              selectedOption={answers[currentQuestionIndex]}
            />
          )}
        </>
      )}
      
      {gameState === 'result' && (
        <ResultScreen 
          score={score} 
          totalQuestions={allQuestions.length}
          onRestart={handleRestart}
        />
      )}
    </AppContainer>
  );
}

export default App;
